import { render } from "./QuestionsPerformanceBlock.vue?vue&type=template&id=0b401e2a&scoped=true"
import script from "./QuestionsPerformanceBlock.vue?vue&type=script&lang=js"
export * from "./QuestionsPerformanceBlock.vue?vue&type=script&lang=js"

import "./QuestionsPerformanceBlock.vue?vue&type=style&index=0&id=0b401e2a&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b401e2a"]])

export default __exports__